import { PromiseVoidFunction, Translate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

import { CreateAssociationButton } from './CreateAssociationButton';
import { CreateAssociationPanelLoader } from './CreateAssociationPanel.loader';
import { CreateAssociationPanelAuthenticationDetails } from './CreateAssociationPanelAuthenticationDetails';
import { CreateAssociationVerificationCodeForm } from './CreateAssociationVerificationCodeForm';

type CreateAssociationPanelProps = {
   readonly onAssociationCreateSuccess: PromiseVoidFunction;
};

export const CreateAssociationPanel = (props: CreateAssociationPanelProps): JSX.Element => {
   return (
      <CreateAssociationPanelLoader>
         {({ authenticationDetails }) => (
            <StyledFlex direction={'column'} gap={'16px'}>
               <Translate>{mfaSettingsTranslationKeys.mfaInfo}</Translate>
               <CreateAssociationPanelAuthenticationDetails authenticationDetails={authenticationDetails} />
               <Translate>{mfaSettingsTranslationKeys.enterVerificationCodeFromAuthenticatorApp}</Translate>
               <CreateAssociationVerificationCodeForm>
                  {({ handleSubmit }) => (
                     <CreateAssociationButton
                        secret={authenticationDetails.secret}
                        handleSubmit={handleSubmit}
                        onSuccess={props.onAssociationCreateSuccess}
                     />
                  )}
               </CreateAssociationVerificationCodeForm>
            </StyledFlex>
         )}
      </CreateAssociationPanelLoader>
   );
};
